import { footerContainerSx } from './Footer.style';
import { Box, useTheme } from '@mui/material';
import { Text } from '../Text/Text';
import { Copy } from '../../copy/Copy';

export const Footer = () => {
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: theme.palette.background.default,
        ...footerContainerSx,
      }}
    >
      <Text text={Copy.generate('Global.tagline')} />
    </Box>
  );
};
